import { useNavigate } from 'react-router-dom'
import { RoutesPath } from '../../configs/routes-path'

export const useNavigateRoute = () => {
  const navigate = useNavigate()

  const navigateTo = (route: RoutesPath | string) => navigate(route)

  return {
    navigateTo
  }
}
